import ActionType from '../actions/ActionType'
// TODO: figure out why deleting a phone number with a dependency doesn't trigger the modal

export default (
	state = {
		dialogOpen: false,
		errors: null,
		errorsEntity: null,
	},
	action,
) => {
	switch (action.type) {
		case ActionType.Data.CREATE_FAILURE:
			if (action.payload) {
				return {
					...state,
					errors: action.payload,
					errorsEntity: action?.entityType,
				}
			}
			return state
		case ActionType.Data.READ_FAILURE:
			if (action.payload) {
				return {
					...state,
					errors: action.payload,
					errorsEntity: action.entityType,
				}
			}
			return state
		case ActionType.Data.UPDATE_FAILURE:
			if (action.payload) {
				return {
					...state,
					errors: action.payload,
					errorsEntity: action?.entityType,
				}
			}
			return state
		case ActionType.Data.DELETE_FAILURE:
			if (action.payload) {
				return {
					...state,
					errors: action.payload,
					errorsEntity: action?.entityType,
				}
			}
			return state
		case ActionType.Data.LIST_FAILURE:
			if (action.payload) {
				return {
					...state,
					errors: action.payload,
					errorsEntity: action?.entityType,
				}
			}
			return state
		case ActionType.View.TOGGLE_ERRORS_DIALOG:
			if (action.payload) {
				return {
					...state,
					dialogOpen: true,
				}
			}

			return {
				...state,
				dialogOpen: false,
				errors: null,
				errorsEntity: null,
			}
		case ActionType.Data.VALIDATION_FAILURE:
			if (action.errors && action.errors.length) {
				return {
					...state,
					errors: {
						message:
							(action.errorsText &&
								typeof action.errorsText === 'string' &&
								action.errorsText
									.replaceAll('data.', ' ')
									.replaceAll('.', ' ')) ||
							'There was an error',
						additional_errors: action.errors,
					},
					errorsEntity: action.entityType,
				}
			}
			return state
		default:
			return state
	}
}
